import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

const SKELETON_ROWS = ["alpha", "bravo", "charlie"];

type RepairMaterialEntry = {
	id?: string | number | null;
	quantity?: number | null;
	name?: string | null;
};

type RepairMaterialsTableProps = {
	materials: RepairMaterialEntry[];
	loading?: boolean;
	onRemove: (material: RepairMaterialEntry) => void;
};

export function RepairMaterialsTable({
	materials,
	loading = false,
	onRemove,
}: RepairMaterialsTableProps) {
	const renderSkeleton = () => (
		<TableBody>
			{SKELETON_ROWS.map((rowKey) => (
				<TableRow key={`repair-material-${rowKey}`} className="animate-pulse">
					<TableCell>
						<div className="h-4 w-16 rounded bg-muted/70" />
					</TableCell>
					<TableCell>
						<div className="h-4 w-40 rounded bg-muted/60" />
					</TableCell>
					<TableCell className="text-right">
						<div className="ml-auto h-8 w-20 rounded bg-muted/50" />
					</TableCell>
				</TableRow>
			))}
		</TableBody>
	);

	return (
		<div className="tp-RepairForm__materialTable overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[100px]">Qnt.</TableHead>
						<TableHead>Material</TableHead>
						<TableHead className="w-[120px] text-right">Ações</TableHead>
					</TableRow>
				</TableHeader>
				{loading ? (
					renderSkeleton()
				) : (
					<TableBody>
						{materials.map((material, index) => {
							const rowKey =
								material.id ?? `${material.name ?? "material"}-${index}`;

							return (
								<TableRow key={rowKey}>
									<TableCell>{material.quantity ?? "-"}</TableCell>
									<TableCell>{material.name ?? "-"}</TableCell>
									<TableCell className="text-right">
										<Button
											variant="secondary"
											size="sm"
											onClick={() => onRemove(material)}
											disabled={loading}
										>
											Remover
										</Button>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				)}
			</Table>
		</div>
	);
}
